var React = require('react');

function ChartArea (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.25 24c.412 0 .75.338.75.75v2.5c0 .412-.338.75-.75.75H.75a.753.753 0 0 1-.75-.75V4.75C0 4.338.338 4 .75 4h2.5c.412 0 .75.338.75.75V24h27.25zM23.294 9.969a.75.75 0 0 1 1.087.294L30 22.001H6v-6.5l5.425-9.044a.752.752 0 0 1 1.244-.063L18 13.5z"}));
}

ChartArea.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ChartArea;

ChartArea.default = ChartArea;
